const landingTypesList = [
  '/',
  '/fullPrice',
  '/discount',
  '/optionsa',
  '/optionsb',
  '/optionsc',
  '/optionsd',
  '/optionse',
  '/optionsf',
  '/optionsx',
  '/optionsy',
  '/optionsg',
  '/optionsh',
  '/optionsj',
  '/latam',
  '/intro',
  '/promo',
  '/trial',
  '/discountb',
  '/up',
];

export default landingTypesList;
